import React from 'react';
import styled from 'styled-components';
import SearchTextField from '../SearchTextField';
import IconSearch from '../../assets/svgs/header/search.svg';
var SCSearchIcon = styled(IconSearch).withConfig({
  displayName: "Search__SCSearchIcon",
  componentId: "sc-194w6b2-0"
})(["cursor:pointer;"]);

var Search = function Search(_ref) {
  var isActive = _ref.isActive,
      onClick = _ref.onClick;
  return isActive ? /*#__PURE__*/React.createElement(SearchTextField, {
    onSearchIconClick: onClick,
    iconSize: 40
  }) : /*#__PURE__*/React.createElement(SCSearchIcon, {
    onClick: onClick,
    size: 40
  });
};

export default Search;